import { createStyles } from "antd-style"

export const useStyle = createStyles(({ css, token }) => {
    const antCls = "ant"
    return {
        customTable: css`
            .${antCls}-table {
                .${antCls}-table-container {
                    .${antCls}-table-body, .${antCls}-table-content {
                        scrollbar-width: thin;
                        scrollbar-color: #eaeaea transparent;
                        scrollbar-gutter: stable;
                    }
                }

                thead .${antCls}-table-selection-column {
                    &::before {
                        position: absolute;
                        top: 50%;
                        inset-inline-end: 0;
                        width: 1px;
                        height: 1.6em;
                        transform: translateY(-50%);
                        content: "";
                        background-color: ${token.colorBorderSecondary};
                    }
                }
            }
        `
    }
})
